import React from "react";

const TopSale = ({ topSales }) => {
  return (
    <div className="bg-white shadow rounded-lg">
      <h2 className="p-4 text-xl font-semibold">Top Sales Representatives</h2>
      <div className="overflow-x-auto min-w-full">
        <table className="min-w-full table-auto">
          <thead className="bg-[#361D3214]">
            <tr>
              <th className="px-4 py-4 text-left text-sm font-semibold text-gray-600 min-w-[170px]">
                Employee Name
              </th>
              <th className="px-4 py-4 text-left text-sm font-semibold text-gray-600 min-w-[250px]">
                Target to achievement ratio
              </th>
              <th className="px-4 py-4 text-left text-sm font-semibold text-gray-600 min-w-[170px]">
                Revenue Generated
              </th>
            </tr>
          </thead>
          <tbody>
            {topSales?.employeeProgress?.length > 0 ? (
              topSales?.employeeProgress?.map((salesRep, index) => (
                <tr key={index} className="p-4 py-6 border-b last:border-none">
                  <td className="flex items-center py-3 px-4">
                    {salesRep.employee.logo ? (
                      <img
                        className="w-[25px] h-[25px] rounded-full"
                        src={salesRep.employee.logo}
                        alt={salesRep.employee.logo}
                      />
                    ) : (
                      <span className="flex w-[25px] h-[25px] bg-gray-200 rounded-full items-center justify-center">
                        <p className="font-normal text-gray-400 text-lg">
                          {salesRep.employee.name?.slice(0, 1)}
                        </p>
                      </span>
                    )}

                    <span className="ml-4">{salesRep.employee.name}</span>
                  </td>
                  <td className="py-2 px-4">
                    <div className="flex flex-col">
                      <div className="flex flex-row justify-between">
                        <span>
                          {`${salesRep.convertedLeadsCount}/${salesRep.counts?.total} `}
                        </span>
                        <span>
                          {salesRep.convertedLeadsCount > 0 &&
                          salesRep.target > 0
                            ? `(${(
                                (salesRep.convertedLeadsCount /
                                  salesRep.counts?.total) *
                                100
                              ).toFixed(2)}%)`
                            : "(0%)"}
                        </span>
                      </div>
                      <div className="relative w-full h-2 bg-gray-200 rounded mt-2">
                        <div
                          className="absolute top-0 left-0 h-full bg-red-500 rounded"
                          style={{
                            width: `${
                              (salesRep.convertedLeadsCount /
                                salesRep.counts?.total) *
                              100
                            }%`,
                          }}
                        ></div>
                      </div>
                    </div>
                  </td>
                  <td className="py-2 px-4 text-gray-700 text-center">
                    AED {salesRep.achieved}
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="7" className="text-center text-gray-500 py-4">
                  No topsale found.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default TopSale;
